import FlightConfirmedModal from './FlightConfirmedModal';

export default FlightConfirmedModal;
